
import React from "react";
import { MapPin, ExternalLink } from "lucide-react";

const ContactMap = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-kufi font-bold">موقعنا على الخريطة</h2>
        <a 
          href="https://maps.app.goo.gl/SQpYf8GpXBdtBb3M9" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="inline-flex items-center gap-2 bg-primary text-white hover:bg-primary/90 px-4 py-2 rounded-lg transition-colors group"
        >
          <MapPin className="w-5 h-5" />
          <span>اذهب إلى الموقع</span>
          <ExternalLink className="w-4 h-4 group-hover:scale-110 transition-transform" />
        </a>
      </div>
      <a 
        href="https://maps.app.goo.gl/SQpYf8GpXBdtBb3M9" 
        target="_blank" 
        rel="noopener noreferrer"
        className="block rounded-xl overflow-hidden shadow-lg h-[450px] relative group cursor-pointer"
      >
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14498.698926434357!2d45.5923384!3d24.6317508!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fe2b376988d8675%3A0x70ecf7bbd069cecd!2z2LTYsdmD2Kkg2KfZhNmB2YbZiNmGINin2YTYrdiv2YrYq9ip!5e0!3m2!1sar!2ssa!4v1714597839674!5m2!1sar!2ssa" 
          width="100%" 
          height="100%" 
          style={{ border: 0, pointerEvents: 'none' }} 
          allowFullScreen={true} 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"
          title="موقعنا على الخريطة"
        ></iframe>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
          <div className="opacity-0 group-hover:opacity-100 transition-opacity bg-primary text-white px-6 py-3 rounded-lg flex items-center gap-2 shadow-lg">
            <MapPin className="w-5 h-5" />
            <span className="font-semibold">افتح في خرائط جوجل</span>
          </div>
        </div>
      </a>
    </div>
  );
};

export default ContactMap;
